import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {checkinlogs,allCheckinlogs,allRegisterlogs, checkinlogExport, checkinQrcode, checkinQrcodeWithApprove,
     gpbyattds,scanFaceSignin,faceDetect,checkinInfoExtend} = api


/**
 * 查找签到记录列表
 */
export async function findCheckinlogs(params) {
    return request({url: checkinlogs, method: 'get', data: params,})
}
/**
 * 查找签到记录列表
 */
export async function findAllCheckinlogs(params) {
    return request({url: allCheckinlogs, method: 'get', data: params,})
}
/**
 * 查找签到记录列表
 */
export async function findAllRegisterlogs(params) {
    return request({url: allRegisterlogs, method: 'get', data: params,})
}
/**
 * 扫码签到
 */
export async function scanCheckinQrcode(params) {
    return request({url: checkinQrcode, method: 'post', data: params,})
}
/**
 * 人脸签到
 */
export async function scanFaceCheckin(params) {
    return request({url: scanFaceSignin, method: 'post', data: params,})
}
/**
 * 人脸签到
 */
export async function detectFace(params) {
    return request({url: faceDetect, method: 'post', data: params,})
}

export async function scanCheckinQrcodeWithApprove(params) {
    return request({url: checkinQrcodeWithApprove, method: 'post', data: params,})
}

/**
 * 查找凭证
 */
export async function findGpbyattds(params) {
    return request({url: gpbyattds, method: 'get', data: params,})
}

export async function exportCheckinlog(params) {
    return request({url: checkinlogExport, method: 'get', data: params})
}

export async function addCheckinInfoExtend(params) {
    return request({url: checkinInfoExtend, method: 'post', data: params})
}





// WEBPACK FOOTER //
// ./src/services/checkin.js